<template>
    <div class="fullTextList">
        <ul class="fullList" v-if="dataFlag">
            <li v-for="item in fullTextList" :key="item.pmid" @click="addCases(item.pmid)">
                <span class="main" v-html="item.title"></span>
                <img class="rightIco" src="../../assets/annOnLine/rightIco.png" />
            </li>
        </ul>
        <div v-if="!dataFlag" class="noDataDiv">
            <img src="../../assets/annOnLine/noData.png" />
            <p>暂时没有数据</p>
        </div>
    </div>
</template>
<script>
import qs from "qs";
import { Toast } from "vant";
import wx from "weixin-js-sdk";

export default {
    name: "fullTextList",
    data() {
        return {
            fullTextList: [],
            dataFlag: true,
            downY: ""
        };
    },
    mounted() {
        this.getData();
        this.$store.dispatch("actionsHead", { type: true, title: "智能客服", iconType: true });
    },
    methods: {
        //获取列表数据
        getData() {
            var url = this.$route.params.params;
            this.$post("https://customer.yuntsg.com/ft/full-text", qs.stringify(url)).then((res) => {
                if (res.code == 0 && res["data"].length > 0) {
                    this.fullTextList = res["data"];
                } else {
                    this.dataFlag = false;
                }
            });
        },
        //申请全文
        addCases(pmid) {
            Toast("请稍候,您申请的全文来源于sc-hub,全文正在加载中");
            this.$get("https://pm.yuntsg.com/folder/addcases?pmids=" + pmid).then((res) => {
                res.data.result = res.data.result.replace("http", "https");
                // console.log(encodeURIComponent(res.data.result),'=======url')
                if (res.code == 0 || res.data.flag == 0) {
                    var isWX = window.__wxjs_environment === "miniprogram";
                    res.data.result = res.data.result.replace("https://attach.pubtsg.com:8088/", "https://attach.pubtsg.com/");
                    if (isWX) {
                        wx.miniProgram.navigateTo({
                            url: "../a/a?pdfUrl=" + encodeURIComponent(res.data.result)
                        });
                    } else {
                        window.location.href = res.data.result;
                    }
                }
            });
        }
    }
};
</script>
<style lang="less">
.fullTextList {
    background-color: #ffffff;
    color: #2f2f2f;
    //   padding: 1rem;
    font-size: 0.9rem;

    .fullList {
        padding: 0.7rem 1rem;

        li {
            padding: 0.6rem 0rem;
            border-bottom: 1px dashed #dddddd;
            overflow: hidden;

            .main {
                color: #272727;
                line-height: 1.5rem;
                float: left;
                width: 80%;
                vertical-align: middle;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;

                b {
                    color: chocolate;
                }
            }

            .rightIco {
                float: right;
                margin-top: 0.3rem;
                height: 0.9rem;
                width: 0.5rem;
                margin-right: 0.1rem;
            }
        }

        // li:last-child {
        //   border-bottom: none;
        // }
    }

    .noDataDiv {
        margin: 0 auto;
        text-align: center;

        img {
            margin-top: 5rem;
            width: 20rem;
        }

        p {
            color: #666666;
        }
    }
}
</style>
